import Quill from "quill";

const Embed = Quill.import("blots/embed");

class LineBreak extends Embed {

  constructor(node) {
    super(node);
    this.contentNode.innerHTML = '<br>';
  }
  
}

LineBreak.blotName = 'line-break';
LineBreak.className = 'ql-line-break';
LineBreak.tagName = 'SPAN';

export default LineBreak;